import React from "react";
import { Col, Row, Divider } from "antd";
import { VerticalGraphValue } from "../../chart/BarChart";
import I18n, { fromSyntax } from "../../../i18n";
import DataPercentList from "../../list/DataPercentList";

export default ({
	colProps, 
	questionIndex = 0, 
	selectChoiceIndex = -1, 
	question, 
	compareQuestion,
	onChoiceClick, 
	colorType,
	percentChoices,
	compareChoices,
	isVertical
})=>{
	return (<Row>
		<Col {...colProps}>
			<VerticalGraphValue 
				showChoice={true}
				index={questionIndex}
				value={question}
				onChoiceClick={onChoiceClick}
				selectChoiceIndex={selectChoiceIndex}
				colorType={colorType} 
				shortQuestion={false}
			/>
		</Col>
		{isVertical ? undefined : 
			<Col xs={0} sm={0} md={2} style={{display:"flex", justifyContent:"center"}}>
				<Divider type="vertical" style={{height:340}}/>
			</Col>}
		<Col {...colProps}>
			<DataPercentList 
				header={fromSyntax(
					I18n.t("question_label_syntax"),
					{
						index:(questionIndex+1), 
						user:I18n.t("user")
					})
				} 
				percentDatas={percentChoices} 
				compareDatas={compareChoices}
				showColor = {false}
				visualColorKey={colorType}
			/>
		</Col>
	</Row>);
};


// WEBPACK FOOTER //
// ./src/components/report/stress/QuestionBox.js